import { ViewGuidesButton, OrderPartButton } from './part_buttons';
import { withOrderContext } from '../Providers/orderContext';
import CopyIcon from '../Generic/clipboard';
import { fromWiki } from '../Generic/fromWiki';
import { iFixitHotSpotItem } from '../Generic/iFixitHotSpotItem';
import { Box, Flex, Link, Text } from '@chakra-ui/react';

const MiscPartRow = ({ datapoint }: { datapoint: iFixitHotSpotItem }) => {
   const sku = fromWiki(datapoint, 'sku') || '';
   const name = fromWiki(datapoint, 'name') || datapoint.description;
   const brand = fromWiki(datapoint, 'brand') || '';

   const itemWikiUrl = fromWiki(datapoint, 'url') || '';

   const copyText = `${brand} ${datapoint.description} ${sku}`;

   return (
      <Flex
         justifyContent="space-between"
         width="100%"
         padding="12px 16px"
         color="gray.800"
         lineHeight="normal"
      >
         <Box flex="1">
            <Link
               href={itemWikiUrl}
               isExternal={true}
               fontSize="16px"
               textAlign="left"
               color="gray.800"
               _hover={{
                  textDecoration: 'none',
               }}
               _visited={{
                  color: 'gray.800',
               }}
            >
               {name}
            </Link>
            {sku && (
               <Text fontSize="14px" textAlign="left" color="gray.600">
                  {sku}
               </Text>
            )}
         </Box>
         <Flex alignItems="center">
            <CopyIcon copyText={copyText} />
         </Flex>
         <Flex justifyContent="flex-end" flexWrap="wrap" alignItems="center" gap={2}>
            <ViewGuidesButton data={datapoint} margin="16px" />
            <OrderPartButton data={datapoint} margin="16px" />
         </Flex>
      </Flex>
   );
};

export default withOrderContext(MiscPartRow);
